import { Heading } from "./Heading.js";

export default Heading;
